/*
 * 接口统一集成模块
 */
import * as replace from './modules/replace'
import * as http from './modules/http'
import * as contract from './modules/contract'

// 默认全部导出
export default {
  replace,
  http,
  contract
}



// WEBPACK FOOTER //
// ./src/http/api.js